import { onMounted, onUnmounted, showErrorMsg, uuid } from '#imports';
import {
  runMarkdownCode,
  runMarkdownCodeResponseOff,
  runMarkdownCodeResponseOn,
} from '../event-bus';

function toggleBorderBreathe(dom: any) {
  if (dom) {
    dom.classList.remove('show-border-breathe');
    // eslint-disable-next-line
    dom.offsetTop;
    dom.classList.add('show-border-breathe');
  }
}

export function useRunCode(editorId: string) {
  // 当前有代码正在运行中
  let running = false;

  function startRunCode(btn: any) {
    running = true;
    if (btn) {
      btn.textContent = '正在运行';
    }
  }

  function stopRunCode(btn: any) {
    running = false;
    if (btn) {
      btn.textContent = '运行';
    }
  }

  function findCodeText(btn: any) {
    const codeBlock = btn.closest('.md-editor-code');
    if (codeBlock) {
      const activeCode =
        codeBlock.querySelector('input:checked + pre code') ||
        codeBlock.querySelector('pre code');
      if (activeCode) {
        return activeCode.textContent;
      }
    }
  }

  function handler(e: any) {
    if (!e.target) return;

    const btn = e.target.closest('.md-editor-code .md-editor-run-button');
    if (!btn) return;

    if (running) {
      return showErrorMsg('代码正在运行中，请稍后再运行');
    }

    startRunCode(btn);
    const timer = window.setTimeout(() => {
      stopRunCode(btn);
    }, 1500);

    const codeText = findCodeText(btn);
    if (codeText) {
      const id = uuid();

      runMarkdownCodeResponseOn(id, (result) => {
        window.clearTimeout(timer);
        stopRunCode(btn);
        if (result) {
          const con = btn.closest('.hetao-inout-container');
          const boxRight = con.querySelector(
            '.hetao-inout-right .md-editor-code',
          );
          boxRight.classList.add('border-breathe');
          const boxResult = document.querySelector('.test-judge-result-box');
          toggleBorderBreathe(boxResult);
          toggleBorderBreathe(con);
        }
      });

      runMarkdownCode({ id, code: codeText });

      window.setTimeout(() => {
        // 超过5秒钟则代表超时了
        runMarkdownCodeResponseOff(id);
      }, 5000);
    }
  }

  onMounted(() => {
    const dom = document.querySelector(`#${editorId}`);
    dom?.addEventListener('click', handler, false);
  });

  onUnmounted(() => {
    const dom = document.querySelector(`#${editorId}`);
    dom?.removeEventListener('click', handler, false);
  });
}
